import AmounttypeModel from '../amounttype/amounttype-model';
import TransactionModel from '../transaction/transaction-model';

export default class TransactionamountModel {
    id: number;
    name: string;
    description: string;
    status: string;
    value: number;
    amounttype: any;
    amounttypeCaption: string;
    transaction: any;
    transactionCaption: string;
    transactionTotal: number;
    transactionTotaldetail: number;
    transactionTotalpayment: number;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.value = datarow.value;
        let amounttype = datarow.amounttype?.data? new AmounttypeModel(datarow.amounttype?.data) : datarow.amounttype;
        this.amounttype = amounttype?.id;
        this.amounttypeCaption = amounttype?.name;
        let transaction = datarow.transaction?.data? new TransactionModel(datarow.transaction?.data) : datarow.transaction;
        this.transaction = transaction?.id;
        this.transactionCaption = transaction?.name;
        this.transactionTotal = transaction?.total || 0; 
        this.transactionTotaldetail = transaction?.totaldetail || 0; 
        this.transactionTotalpayment = transaction?.totalpayment || 0; 
        
    } 

    public static endPoint: string = 'transaction-amounts';
    public static endPointFilter: string = '?populate=*&filters[transaction]=';
    public static url: string = '/transactionamount';

    public static caption: string = 'Additional Value';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        value: 0,
        amounttype: null,
        amounttypeCaption: '',
        transaction: null,
        transactionCaption: '',
        transactionTotal: 0,
        transactionTotaldetail: 0,
        transactionTotalpayment: 0,
        }
    }
        
    public static validations = [
        { name: 'amounttype', nameAlias: 'Type', required: true },
    ]

    public static columns = [
        { name: 'amounttypeCaption', caption: '' },
        { name: 'value', caption: '', type: 'money' },
              
    ]

    public static columnPicklist = [
        { name: 'amounttypeCaption', caption: 'Type' },
        { name: 'value', caption: 'Amount', type: 'money' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
        
}